import { IGlob } from '../../../../_common/application/ts/Glob';
import BaseAttrQueryWidgetStore, {
    IAttrQueryWidgetStoreState,
    IBaseWidgetParameters
} from '../../../../_common/platform/ts/BaseAttrQueryWidgetStore';

import { Constants } from '../../../../_common/platform/ts/Constants';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';

import { AppDispatcher as Dispatcher } from '../../../../pdc-platform/src/ts/dispatcher/AppDispatcher';
import {
    Action,
    AppActions as Actions,
    I,
    check as checkAction
} from '../../../../pdc-platform/src/ts/actions/AppActions';

export interface IGaugeWidgetState extends IAttrQueryWidgetStoreState {}

export type GaugeType = 'circularGauge' | 'linearGauge' | 'barGauge';

export interface IGaugeWidgetParameters extends IBaseWidgetParameters {
    gaugeType?: GaugeType;
}

export class WidgetStore extends BaseAttrQueryWidgetStore<IGaugeWidgetState, Actions, Dispatcher> {
    constructor(glob, dispatcher: Dispatcher, data: any, options: any, globalState: GlobalState) {
        super(glob, dispatcher, data, options, globalState);
    }

    static get(glob, dispatcher: Dispatcher, data, options, globalState) {
        return new WidgetStore(glob, dispatcher, data, options, globalState);
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const action = payload.action;

        switch (action.actionType) {
            case Constants.WORKSPACE_VIEW_SHOW:
                if (this._state.options.workspace === action.id && action.stateId === 1) {
                    //this._state.resizeRequire = true;  //LL: 03.07.18: try, maybe not needed, main - emitChange
                    this.emitChange(true);
                }
                break;
        }

        return true;
    }
}
